// extracted by mini-css-extract-plugin
export default {"pillsContainer":"PillsToolbar_pillsContainer__i95wp","pill":"PillsToolbar_pill__zF5O7","pillBorder":"PillsToolbar_pillBorder__zzogn"};